import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { programEnums } from '../enums'
import { ProgramModel } from '../models'
import { programActions } from '../redux/actions'
import { selectProgram } from '../redux/selectors'
import { programTypes } from '../types'

function useProgram() {
  const dispatch = useDispatch()
  const currentProgram: programTypes.Program = useSelector(selectProgram)

  const setProgram = useCallback((p: programTypes.Program) => {
    dispatch(programActions.update(p))
  }, [dispatch])

  const resetProgram = useCallback(() => {
    dispatch(programActions.update(new ProgramModel({ code: programEnums.codes.UNKNOWN })))
  }, [dispatch])

  return {
    program: currentProgram, resetProgram, setProgram,
  }
}

export default useProgram
